import { Component, TemplateRef, ViewChild } from '@angular/core';
import { AbstractControl, FormBuilder, FormGroup, ValidationErrors, ValidatorFn, Validators } from '@angular/forms';
import { UtilsDataService } from '../services/utils-data.service';
import { ActivatedRoute, Router } from '@angular/router';
import { VendorService } from '../services/vendor.service';
import { SnackBarService } from '../shared/services/snack-bar.service';
import { MatDialog } from '@angular/material/dialog';

@Component({
  selector: 'app-advertise-details-view',
  templateUrl: './advertise-details-view.component.html',
  styleUrl: './advertise-details-view.component.scss'
})
export class AdvertiseDetailsViewComponent {
  @ViewChild('applyFormDialog', { static: false }) applyFormDialog?: TemplateRef<any>;

  rowDetails: any = {};
  applicationLink: boolean = false
  form: FormGroup;
  base64FileData: string | null = null; // To store the base64 string
  selectedFileName: string | null = null;
  fileUpload: string | null = null;
  slug: string = ""

  constructor(

    private router: Router,
    private utilsDataService: UtilsDataService,
    private formBuilder: FormBuilder,
    private vendorService: VendorService,
    private snackbarService: SnackBarService,
    private route: ActivatedRoute,
    private dialog: MatDialog
  ) {
    // this.rowDetails = this.utilsDataService.advertDetails;
    console.log("BBBBBBBBBBB", this.rowDetails)

  }

  ngOnInit(): void {
    this.initJobForm()
    this.route.paramMap.subscribe(params => {
      this.slug = params.get('slug');  // Access the 'id' from the route
    });
    console.log("slug value", this.slug)
    this.advertsSearchBySlug(this.slug)
  }



  initJobForm() {
    this.form = this.formBuilder.group({
      address: ["",],
      name: [""],
      email: [""],
      primary_number: [""],
      secondary_number: [""],
      dob: ['', [Validators.required, this.dobValidator()]],
    })
  }

  dobValidator(): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
      const value = control.value;

      if (!value) return null; // Don't validate empty value (use `Validators.required` separately)

      const dob = new Date(value);

      // Invalid date check
      if (isNaN(dob.getTime())) {
        return { invalidDate: true };
      }

      const today = new Date();
      today.setHours(0, 0, 0, 0); // Set time to midnight for accurate comparison
      dob.setHours(0, 0, 0, 0);

      // Future date check
      if (dob > today) {
        return { futureDob: true };
      }

      // Age calculation
      const age = today.getFullYear() - dob.getFullYear();
      const monthDiff = today.getMonth() - dob.getMonth();
      const dayDiff = today.getDate() - dob.getDate();

      const isBirthdayPassedThisYear =
        monthDiff > 0 || (monthDiff === 0 && dayDiff >= 0);
      const accurateAge = isBirthdayPassedThisYear ? age : age - 1;

      // Age must be 18 or more
      if (accurateAge < 18) {
        return { ageTooYoung: true };
      }

      return null;
    };
  }

  /* dobValidator(): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
      const dob = new Date(control.value);
  
      // Check if the date is invalid
      if (!dob || isNaN(dob.getTime())) {
        return { invalidDate: true };
      }
  
      const today = new Date();
      
      // Check if the date is in the future
      if (dob > today) {
        return { futureDob: true };
      }
  
      // Calculate age in years
      const ageInMilliseconds = today.getTime() - dob.getTime();
      const ageInYears = ageInMilliseconds / (1000 * 60 * 60 * 24 * 365.25); // Approximate number of days in a year
  
      // Check if the age is less than 18
      if (ageInYears < 18) {
        return { ageTooYoung: true };
      }
  
      return null; // No validation errors
    };
  } */


  decodeHtml(html: string): string {
    const txt = document.createElement("textarea");
    txt.innerHTML = html;
    return txt.value;
  }
  getPlainText(html: string): string {
    const decodedHtml = this.decodeHtml(html);
    const plainText = decodedHtml.replace(/<\/?[^>]+(>|$)/g, "");
    return plainText;
  }

  applyNow(obj: any) {
    if (obj.application_method === 'WHITEROBE') {
      this.applicationLink = true
    } else {
      this.router.navigate([obj.application_link])
    }
  }
  openInNewTab(link: string) {
    window.open(link, '_blank');
  }

  onFileSelected(event: any): void {
    const file = event.target.files[0]; // Get the selected 
    this.selectedFileName = file.name
    if (file) {
      this.convertFileToBase64(file);
    }
    console.log("file data", file.name)
  }
  convertFileToBase64(file: File): void {
    const reader = new FileReader();

    // FileReader.onload event will trigger when the file is read
    reader.onload = (e: any) => {
      // Store the Base64 string (e.target.result contains the Base64)
      this.base64FileData = e.target.result;
      this.fileUpload = this.base64FileData.split(',')[1]
      console.log("base64", this.fileUpload)
    };

    // Read the file as a Data URL (Base64 encoded)
    reader.readAsDataURL(file);
  }

  createJobsAdvertsApplication() {

    let reqObj = {
      //"no_of_positions": this.form.value["no_of_positions"],
      "advert_uuid": this.rowDetails.uuid,
      "fileName": this.selectedFileName,
      "advertisement_base64": this.fileUpload,
      "full_name": this.form.value["name"],
      "dob": this.form.value["dob"],
      "primary_number": this.form.value["primary_number"],
      "secondary_number": this.form.value["secondary_number"],
      "email": this.form.value["email"],
      "address": this.form.value["address"]

    };


    console.log("Form", this.form.value);
    console.log("reqObj", reqObj);
    // return false
    this.vendorService.createJobsAdvertsApplication(reqObj).subscribe((resp: any) => {
      console.log("Job created successfully", resp);
      if (resp.statusCode == 200) {
        this.form.reset()
        this.snackbarService.open(resp.supportMessage, 'close', 5000, "center", "top")

        console.log("success");
      }
    });
  }

  advertsSearchBySlug(slug: any) {

    let reqObj = {
      "slug": slug,


    };


    console.log("Form", this.form.value);
    console.log("reqObj", reqObj);
    // return false
    this.vendorService.advertsSearchBySlug(reqObj).subscribe((resp: any) => {
      console.log("Job created successfully", resp);
      if (resp.statusCode == 200) {
        this.rowDetails = resp.data[0]

      }
    });
  }

  openFormModal(): void {
  if (!this.applyFormDialog) {
    console.error('Dialog template not found!');
    return;
  }

  const dialogRef = this.dialog.open(this.applyFormDialog, {
    width: '900px',
    disableClose: false
  });

  dialogRef.afterClosed().subscribe(result => {
    console.log('Dialog closed');
  });
}

}
